export class DialogModelCheckManualBill {
    constructor(
      public invoiceNumber: any,
      public body: any
    ) {}
  }